import { EmbedBlot } from 'parchment';

class TextBreak extends EmbedBlot {}
TextBreak.tagName = 'BR';
TextBreak.blotName = 'textBreak';
TextBreak.className = 'inline';

export default TextBreak;